/**
 * Dynamic "chat"-style routes whose first path segment maps to a module.
 *
 * Single source of truth shared by:
 *  - `AppLayout` — segment → sidebar `component` key (which rail to render)
 *  - `Header`    — segment → canonical route `path` (for the active-link label)
 *
 * Previously these were two hand-kept copies in app-layout.tsx and header.tsx
 * with different shapes; keeping them here prevents the two from drifting.
 * e.g. `/chat/:id` → Explorer, `/translate/:id` → Translate.
 */
const DYNAMIC_CHAT_ROUTES = {
  chat: { component: "free", path: "/" },
  translate: { component: "translate", path: "/translate" },
  "video-insight": { component: "video-insight", path: "/video-insight" },
  "ai-parser": { component: "ai-parser", path: "/ai-parser" },
} as const

/** Resolve a dynamic chat route by its first path segment, or `undefined`. */
export function getDynamicChatRoute(
  segment: string
): { component: string; path: string } | undefined {
  return DYNAMIC_CHAT_ROUTES[segment as keyof typeof DYNAMIC_CHAT_ROUTES]
}
